import script from "./IDType.vue?vue&type=script&setup=true&lang=ts"
export * from "./IDType.vue?vue&type=script&setup=true&lang=ts"

import "./IDType.vue?vue&type=style&index=0&id=646bb789&lang=scss&scoped=true"
import "./IDType.vue?vue&type=style&index=1&id=646bb789&lang=scss"

import exportComponent from "/Users/breeze/data/code/src/gitlab.goiot.net/chargingc/cms/web2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-646bb789"]])

export default __exports__